import { gql } from "@apollo/client";

export default gql`
  mutation extractDocumentData($fileUrl: String!, $isArabic: Boolean) {
    extractDocumentData(fileUrl: $fileUrl, isArabic: $isArabic) {
      ok
      message
      error
    }
  }
`;
